import React from "react";
import SensorBase from "./SensorBase";
import { TChartData } from "../types";
import { TInformationCard } from "../components/InformationCardRenderer";
import { SampleItem, TSensorDataResponse } from "../../../services/sensorData.service";
import dayjs from "dayjs";
import { t } from "../../../services/locale.service";

const FIELD = "leafWetness";
const UNIT = "hrs";

const LeafWetness: React.FC = () => {
  const generateInformationCard = (chartData: TChartData): Array<TInformationCard> => {
    const { normalRange } = chartData;

    if(Array.isArray(normalRange)) {
      const sum = (normalRange as Array<SampleItem>)?.reduce((sum, curr) => sum + Number(curr [FIELD]), 0);
  
      return [{
        cardTitle: t("LeafWetnessHours"),
        value: sum,
        information: "",
        unit: UNIT
      }];
    }

    return [];
  };


  const customProcessFn = (graphData: TSensorDataResponse, startDate: string, endDate: string) => {
    const diff = dayjs(endDate).diff(startDate, "days");
    const isDaily = diff > 1;

    graphData.sample = graphData.sample.map((data) => {
      if(isDaily) {
        data[FIELD] = data["leafWetnessHours"];
      } else {
        data[FIELD] = data[FIELD] as number > 0 ? 1 : 0;
        data.max = 1;
        data.min = 0;
        data["WetType"] = data[FIELD] > 0 ? "Wet" : "Dry";
      }
      return data;
    });

    return JSON.parse(JSON.stringify(graphData)) as TSensorDataResponse;
  };

  return (
    <SensorBase 
      field={FIELD} unit={UNIT} 
      customProcessFn={customProcessFn} 
      customInformationCards={generateInformationCard} 
      informationCardWidth="150px"
    />
  );
};

export default LeafWetness;


